import React from "react";
import "./HeroSection.css";
import homeLogo from "../../../assets/images/homePageLogo.png";
import { FaArrowRight } from "react-icons/fa";

const scrollToTalepFormu = (e) => {
  e.preventDefault();
  const el = document.getElementById("talep-formu");
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

const HeroSection = () => {
  return (
    <section className="hero-section">
      <div className="hero-left">
        <div className="hero-content">
          <h1 className="hero-title">
            Her An İletişime
            <br />
            Daha Yakın!
          </h1>
          <p className="hero-description">
            Dilin Sesi Sözcüklerle Değil Azimle Yankılanır; Afazi
            <br />
            Sınırlarını Beraber Aşalım
          </p>
          <div className="hero-buttons-wrapper">
            <div className="hero-buttons">
              <a href="#talep-formu" className="btn-primary" onClick={scrollToTalepFormu}>
                İletişime Geç <FaArrowRight className="hero-arrow-icon" />
              </a>
              <a href="/iletisim" className="btn-secondary">
                Daha Fazla Bilgi Al
              </a>
            </div>
            <a href="#talep-formu" className="btn-orange" onClick={scrollToTalepFormu}>
              Talep Formu Doldur
            </a>
          </div>
        </div>
      </div>
      <div className="hero-right">
        <img src={homeLogo} alt="Hero" className="hero-image" />
      </div>
    </section>
  );
};

export default HeroSection;
